export default "__VITE_ASSET__CB7ag4i4__"